import { render, staticRenderFns } from "./CustomerFieldFormGroup.vue?vue&type=template&id=22d1c840"
import script from "./CustomerFieldFormGroup.vue?vue&type=script&lang=js"
export * from "./CustomerFieldFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports